//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../../services/reports";
import moment from "moment";
import pointsservice from "../../../../services/points";

const initialState = {
	instances: {},
};


/////////
//types
export const types = {
	INIT_COMPONENT: "components/samplesummarytable/INIT_COMPONENT",
	LOAD_DATA: "components/samplesummarytable/LOAD_DATA",
	SET_COMPONENT_DATA: "components/samplesummarytable/SET_COMPONENT_DATA",
};

function initComponent(state, action){
	const id = action.payload.id;
	const component = action.payload.component;
	//do nothing if it's already init
	if(state.instances.id){
		return state;
	}
	let componentData = {
		sampleSummaries: [],
	};
	return {...state, instances: {...state.instances, [id]: componentData}};
}

function setComponentData(state, action){
	const id = action.payload.id;
	const componentData = action.payload.componentData;
	return {...state, instances: {...state.instances, [id]: componentData}};
}

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.INIT_COMPONENT:{
				return initComponent(state, action);
			}
			case types.LOAD_DATA:{
				return state;
			}
			case types.SET_COMPONENT_DATA: {
				return setComponentData(state, action);
			}
			default:
				return state;
		}
	}
};

function* getPointNames(component){
	let pointNames = [];
	let pointIds = [];
	component.inputs.forEach(input => {
		input.values.forEach(value => {
			if(input.type === "Dynamic"){
				pointIds.push(value.value);
			}
		});
	});

	const pointDetails = yield all(pointIds.map(pointId => call(pointsservice.TrendableObjectGetObject, pointId)));
	pointDetails.forEach(point => {
		pointNames.push({
			name: point.name,
			pointId: point.objectID,
		});
	});

	return pointNames;
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([ this.loadData()]);
    },

	*loadData(){
		yield takeEvery(types.LOAD_DATA, function*({payload}){		
			const component = payload.component;
			const ruleInstanceId = component.ruleInstanceId;
			const id = payload.id;
			const fromDate = moment(payload.timePeriod.startDate);
			const toDate = moment(payload.timePeriod.endDate);
			const componentData = {
				sampleSummaries: [],
			};
			const sampleSummaries = yield call(reportsservice.GetSampleSummary , ruleInstanceId, fromDate, toDate);
			
			if(sampleSummaries instanceof Error || !sampleSummaries) {
				return;
			} else {
				const pointDetails = yield all(
					sampleSummaries.map(sampleSummary => call(pointsservice.TrendableObjectGetObject, sampleSummary.pointId))
				);
				if (pointDetails instanceof Error || !pointDetails) {
					return;
				}
				sampleSummaries.forEach(sampleSummary => {
					let matching = pointDetails.find(pointName => {return pointName.objectID == sampleSummary.pointId});
					let summary = {
                        pointName: matching ? (matching.description ? matching.description : matching.name) : "",
						totalSamples: sampleSummary.totalSamples,
						samplesAbove: sampleSummary.samplesAbove,
						samplesBelow: sampleSummary.samplesBelow,
						totalHours: sampleSummary.totalHours,
						hoursOutsideRange: sampleSummary.hoursOutsideRange,
						percentageHoursOutsideRange: "0.0%",
						percentageSamplesOutsideRange: "0.0%",
					};
					if(sampleSummary.totalHours && sampleSummary.hoursOutsideRange){
						const percent = 100 * sampleSummary.hoursOutsideRange / sampleSummary.totalHours;
						//rounding to 1 dp and adding %
						summary.percentageHoursOutsideRange = percent.toFixed(1) + "%";
					}
					if(sampleSummary.totalSamples && (sampleSummary.samplesAbove + sampleSummary.samplesBelow)){
						const percent = 100 * (sampleSummary.samplesAbove + sampleSummary.samplesBelow) / sampleSummary.totalSamples;
						//rounding to 1 dp and adding %
						summary.percentageSamplesOutsideRange = percent.toFixed(1) + "%";
					}
					componentData.sampleSummaries.push(summary);
				});
			}
			yield put(actions.setComponentData(id, componentData));
			if(payload.onLoadComplete){
				payload.onLoadComplete();
			}
		});
		
	},
};

////////
//actions
export const actions = {
	initComponent(id, component){
		return {
			type: types.INIT_COMPONENT,
			payload: {id, component}
		};
	},
	loadData(id, component, timePeriod, onLoadComplete){
		return {
			type: types.LOAD_DATA,
			payload: {id, component, timePeriod, onLoadComplete}
		};
	},
	setComponentData(id, componentData){
		return {
			type: types.SET_COMPONENT_DATA,
			payload: {id, componentData},
		}; 
	},
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Tables/SampleSummaryTable/redux.js